import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { getLocale } from '../../../helpers/dates';
import { format } from 'date-fns';
import { alignTimezone } from '../../../helpers/dates';
import { useTranslation } from 'react-i18next';
import { getAssociateStatusAccount } from '../../../actions/associatesActions';
import styles from './Commissiontable.module.css';
import Accordion from '../../../components/Common/Accordion/Accordion';
import AccordionCommision from '../../../components/Points/AccordionStatus/AccordionCommision';
import ContentApp from '../../../components/ContentApp';
import NavSelector from '../../../components/NavSelector/NavSelector';
import AccountHeader from '../../../components/AccountHeader/AccountHeader';
import { SkeletonCommissionsConcierge } from '../../../components/Skeletons/SkeletonPoints';
import AccordionContainer from '../../../components/Points/AccordionStatus/AccordionContainer';

const CommissionTable = ({ history }) => {
  const { t } = useTranslation();

  const jwt = useSelector((state) => state.associates.jwt);
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);

  const [loading, setLoading] = useState(true);

  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);

  const [categories, setCategories] = useState([]);
  const [nestedStructure, setNestedStructure] = useState(false);
  const [createDate, setCreateDate] = useState();

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await welletContext.apis.tickets.get(`associates/commission`);
      if (response.status === 200) {
        const isNested = response.data.commissionSchemas.some(
          item => item.commissionSchemas && Array.isArray(item.commissionSchemas)
        );
        
        setNestedStructure(isNested);
        setCategories(response.data.commissionSchemas);
        setCreateDate(response.data.createDate);
      } else {
        console.error('Failed to fetch data', response);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    dispatch(getAssociateStatusAccount(welletContext, jwt));
  }, [jwt]);

  const renderSimpleStructure = () => (
    categories.map((category, index) => (
      <div key={index}>
        <div className={`${index === 0 ? styles.firstLine : styles.line}`}></div>
        <AccordionCommision
          t={t}
          categories={categories}
          key={index}
          category={category}
          categoryName={t(category.reservationType)}
          children={
            <>
              <div>
                <div className='text-secondary font-extra-small pb-1 mt-1'>
                  {t('commisionTable.subtotalTheCustomersAccount')}
                </div>

                <div className='text-secondary mb-2 font-extra-small mt-3'>
                  {t('commisionTable.paymentTerm')}
                </div>
                <div
                  className={`${styles.affliatedCard} text-secondary font-smaller semi-bold `}
                >
                  {t('commisionTable.accountClosure')}
                </div>
              </div>
            </>
          }
          index={index}
        />
      </div>
    ))
  );

  const renderNestedStructure = () => (
    categories.map((group, groupIndex) => (
      <div key={groupIndex}>
        <div className={`${groupIndex === 0 ? styles.firstLine : styles.line}`}></div>
        <AccordionContainer
          t={t}
          categories={group.commissionSchemas}
          key={`group-${groupIndex}`}
          category={group}
          categoryName={group.showName}
          isGroup
          children={
            group.commissionSchemas.map((category, index) => (
              <div key={index}>
                <div className={`${index === 0 ? styles.firstLine : styles.line}`}></div>
                <AccordionCommision
                  t={t}
                  categories={group.commissionSchemas}
                  key={index}
                  category={category}
                  categoryName={t(category.reservationType)}
                  children={
                    <>
                      <div>
                        <div className='text-secondary font-extra-small pb-1 mt-1'>
                          {t('commisionTable.subtotalTheCustomersAccount')}
                        </div>

                        <div className='text-secondary mb-2 font-extra-small mt-3'>
                          {t('commisionTable.paymentTerm')}
                        </div>
                        <div
                          className={`${styles.affliatedCard} text-secondary font-smaller semi-bold `}
                        >
                          {t('commisionTable.accountClosure')}
                        </div>
                      </div>
                    </>
                  }
                  index={index}
                />
              </div>
            ))
          }
          index={groupIndex}
        />
      </div>
    ))
  );

  return (
    <>
      <AccountHeader title={app.titleWeb} icon='config' pathName='/configuration' />
      <ContentApp menu header>
        {loading ? (
          <div className='mt-1'>{SkeletonCommissionsConcierge()}</div>
        ) : (
          <div className='fade-up card mt-2'>
            <div className='bold px-3 pt-3'>{t('commisionTable.commissionTableTitle')}</div>
            <div className=' text-secondary px-3 font-small'>
              {t('ratedSince')}{' '}
              <span className='text-capitalize'>
                {format(alignTimezone(createDate), 'MMM d, yyyy', { locale })}
              </span>
            </div>

            <div className='mt-3'>
              {nestedStructure ? renderNestedStructure() : renderSimpleStructure()}
            </div>
           <Accordion
              title={t('commisionTable.commissionInformation')}
              content={t('infoStatusDescriptionConcierge', { organization: app.name })}
              type={'points'}
            />
            <Accordion
              title={t('commisionTable.paymentMethods')}
              content={t('pointsExpirationDescriptionConcierge')}
              type={'points'}
            /> 
          </div>
        )}
      </ContentApp>
      <NavSelector history={history} />
    </>
  );
};

export default CommissionTable;